import { render } from "./NewBasket.vue?vue&type=template&id=a7870576&scoped=true"
import script from "./NewBasket.vue?vue&type=script&lang=js"
export * from "./NewBasket.vue?vue&type=script&lang=js"

import "./NewBasket.vue?vue&type=style&index=0&id=a7870576&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7870576"]])

export default __exports__